<template>
  <div class="home" :class="{'has-index': items && items.length}">
    <!-- <transition :name="hasScrolled !== 'true' ? 'introTrans' : ''" @after-leave="resetBody()">
      <home-intro
        v-touch:swipe.up="swipeIntro"
        v-if="!hasScrolled && skipIntro !== 'true'"
        :hasScrolled="hasScrolled"
      />
    </transition> -->
    <div class="slider-wrap">
      <transition name="homeSliderTrans" mode="out-in">
        <home-slider
          :isMobile="isMobile"
          v-if="slides && slides.length"
          :slide="slides[activeProject]"
          :key="slides[activeProject]._id"
          :hasIndex="items && items.length"
        />
      </transition>
      <div v-if="items && items.length" class="arrow" data-hover="link" @click="scroll()"></div>
    </div>
    <div class="index" v-if="items && items.length">
      <WorksLoader :items="items" :payload="{fullView: false}"></WorksLoader>
    </div>
    <div v-if="hasScrolled" @click="nextProject()">
      <Icon
        data-hover="link"
        :class="'iconSize changeSlide not-desktop ' + (items && items.length ? 'has-index' : '')"
        icon="change-slide"
      />
    </div>
  </div>
</template>

<script>
import HomeIntro from "@components/HomeIntro";
import HomeSlider from "@components/homeSlider/HomeSlider";
import heroSlideService from "@api/modules/heroSlideService";
import WorksLoader from "@components/worksLoader/WorksLoader";
import homeService from "@api/modules/homeService";

import { mapGetters } from "vuex";

export default {
  name: "Home",
  components: {
    HomeIntro,
    HomeSlider,
    WorksLoader
  },
  metaInfo() {
    return {
      title: 'Dinamo Digitale',
      meta: [
        { name: 'og:title', content: 'Home' + ' | Dinamo Digitale'},
        { name: 'twitter:title', content: 'Home' + ' | Dinamo Digitale'},
        { name: 'description', content: this.getAbstract()},
        { name: 'og:description', content: this.getAbstract()},
        { name: 'twitter:description', content: this.getAbstract()},
        { name: 'keywords', content: this.getDescription()},
        { name: 'og:type', content: 'website'},
        { name: 'og:url', content: window.location.href},
        { name: 'og:image', content: this.getPageImage()},
        { name: 'twitter:image', content: this.getPageImage()},
      ]
    }
  },
  data() {
    return {
      resourceUrl: process.env.VUE_APP_RESOURCES,
      hasScrolled: false,
      activeProject: 0,
      sliding: false,
      slides: [],
      items: [],
      defaultTitle: 'Home',
      defaultDescription: 'Integriamo marketing e tecnologia',
      defaultKeywords: 'consulenza design marketing sviluppo integrazione'
    };
  },
  mounted() {
    this.getPage();
    this.getSlides();
    this.loadGrid();
    // if (!this.skipIntro) {
    //   document.getElementsByTagName('body')[0].classList.add('is-intro')
    //   var scoreDown = 0;
    //   var goal = 8;
    //   var t = 0;
    //   var impedance = 3000;
    //   var vm = this;
    //   function mouseWheelEvent(event) {
    //     if (scoreDown >= goal) {
    //       scoreDown = 0;
    //       clearTimeout(t);
    //       if ("onwheel" in window) {
    //         window.removeEventListener("wheel", mouseWheelEvent);
    //       } else {
    //         window.removeEventListener("mousewheel", mouseWheelEvent);
    //       }
    //       vm.hasScrolled = true;
    //       vm.$store.commit("skipIntro", true);
    //     } else {
    //       scoreDown++;
    //       clearTimeout(t);
    //       t = setTimeout(function() {
    //         scoreDown = 0;
    //       }, impedance);
    //     }
    //   }
    //   if ("onwheel" in window) {
    //     window.addEventListener("wheel", mouseWheelEvent);
    //   } else {
    //     window.addEventListener("mousewheel", mouseWheelEvent);
    //   }
    // } else {
    //   this.hasScrolled = true;
    //   this.$store.commit("skipIntro", true);
    // }
  },
  beforeRouteUpdate(to, from, next) {
    this.getSlides();
    next();
  },
  methods: {
    getPage() {
      this.$store.dispatch("getPage", 'la-nostra-visione');
    },
    getAbstract() {
      if (this.page && this.page.abstract) {
        return this.page.abstract
      }
      return this.defaultDescription
    },
    getDescription() {
      if (this.page && this.page.description) {
        return this.page.description
      }
      return this.defaultKeywords
    },
    getPageImage() {
      if (this.page && this.page.mainImage && this.page.mainImage.file && this.page.mainImage.file.path) {
        return this.resourceUrl + this.page.mainImage.file.path
      } else if (this.page && this.page.mobileImage && this.page.mobileImage.file && this.page.mobileImage.file.path) {
        return this.resourceUrl + this.page.mobileImage.file.path
      }
      return undefined
    },
    resetBody() {
      document.getElementsByTagName('body')[0].classList.remove('is-intro')
      this.$store.commit("setShownav", true);
    },
    scroll() {
      window.scrollTo({
        behavior: "smooth",
        top: window.innerHeight
      });
    },
    swipeIntro() {
      this.$store.commit("skipIntro", true);
      this.hasScrolled = true;
    },
    nextProject() {
      if (this.sliding === false) {
        this.sliding = true;
        let projectsNum = this.slides.length;
        if (this.activeProject === projectsNum - 1) {
          this.activeProject = 0;
        } else {
          this.activeProject++;
        }
        setTimeout(() => {
          this.sliding = false;
        }, 800);
      }
    },

    getSlides() {
      heroSlideService.get().then(
        res => {
          this.slides = res.data;
        },
        e => {
          console.log(e);
        }
      );
    },

    loadGrid() {
      homeService.get().then(res => {
        this.items = res.data;
      });
    }
  },
  computed: {
    ...mapGetters({
      skipIntro: true,
      isMobile: "getIsMobile",
      page: "getPage"
    })
  },
  watch: {
    slides: function(nSlides, oSlides) {
      let key = "mainImage";
      if (this.isMobile) {
        key = "mobileImage";
      }
      oSlides.map(slide => {
        if (!this.isMobile) {
          if (slide[key] && slide[key].file && slide[key].file.path) {
            let img = new Image();
            img.src = this.resourceUrl + slide[key].file.path;
          }
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@assets/scss/_importer.scss";

.index {
  padding: 64px;
  @include breakpoint(medium down) {
    padding: 64px 0;
  }
}

.slider-wrap {
  position: relative;
  .arrow {
    background-image: url("../assets/img/D_scrolldown.svg");
    height: 64px;
    width: 64px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 3;
    @include breakpoint(medium down) {
      bottom: -64px;
    }
  }
}

/deep/ .changeSlide {
  position: absolute;
  bottom: 64px;
  right: 64px;
  cursor: pointer;
  z-index: 3;
  @include breakpoint(medium down) {
    bottom: 0;
    right: 0;
  }
  &.has-index {
    @include breakpoint(medium down) {
      bottom: 64px;
    }
  }
}
.introTrans-enter {
  @include transform(translateY(0));
}

.introTrans-enter-to {
  @include transform(translateY(0));
}

.introTrans-leave {
  @include transform(translateY(0));
}

.introTrans-leave-to {
  @include transform(translateY(-100%));
}

.introTrans-enter-active,
.introTrans-leave-active {
  -webkit-transition: all 1.2s ease-in-out;
  -moz-transition: all 1.2s ease-in-out;
  -o-transition: all 1.2s ease-in-out;
  transition: all 1.2s ease-in-out;
}

.home.has-index {
  background: $light-gray;
}

/deep/ {
  &.intro-grid {
    z-index: 4;
  }
  &.home-slider-grid {
    z-index: 2;
  }
}

.homeSliderTrans-enter-active,
.homeSliderTrans-leave-active {
  -webkit-transition-duration: 0.8s;
  -moz-transition-duration: 0.8s;
  -o-transition-duration: 0.8s;
  transition-duration: 0.8s;
  -webkit-transition-property: opacity;
  -moz-transition-property: opacity;
  -o-transition-property: opacity;
  transition-property: opacity;
  -webkit-transition-timing-function: ease-in-out;
  -moz-transition-timing-function: ease-in-out;
  -o-transition-timing-function: ease-in-out;
  transition-timing-function: ease-in-out;
}

.homeSliderTrans-leave,
.homeSliderTrans-enter-to {
  opacity: 1;
}

.homeSliderTrans-enter,
.homeSliderTrans-leave-to {
  opacity: 0;
}

// .homeSliderTrans-enter {
//   z-index: 2;
//   opacity: 0;
// }
// .homeSliderTrans-enter-to {
//   z-index: 2;
//   opacity: 1;
// }
// .homeSliderTrans-leave {
//   z-index: -1;
//   opacity: 1;
// }
// .homeSliderTrans-leave-to {
//   z-index: -1;
//   opacity: 1;
// }

// .homeSliderTrans-leave-active {
//   z-index: -1;
//   position: absolute;
//   width: 100vw;
//   left: 0;
//   top: 0;
//   // @include breakpoint(large up) {
//   //   top: 64px;
//   //   left: 64px;
//   //   width: calc(100vw - 128px);
//   // }
// }

// // .homeSliderTrans-leave {
// //   position: absolute;
// //   width: 100vw;
// //   left: 0;
// //   top: 0;
// //   @include breakpoint(large up) {
// //     top: 64px;
// //     left: 64px;
// //     width: calc(100vw - 128px);
// //   }
// //   & /deep/ {
// //     z-index: 2;
// //   }
// // }

// // .homeSliderTrans-leave-to {
// //   position: absolute;
// //   width: 100vw;
// //   left: 0;
// //   top: 0;
// //   @include breakpoint(large up) {
// //     top: 64px;
// //     left: 64px;
// //     width: calc(100vw - 128px);
// //   }
// //   & /deep/ {
// //     z-index: 2;
// //     .cell {
// //       @include transform(translateY(128px));
// //       opacity: 0;
// //     }
// //   }
// // }

// .homeSliderTrans-enter-active,
// .homeSliderTrans-leave-active {
//   -webkit-transition: all 0.8s ease-in-out;
//   -moz-transition: all 0.8s ease-in-out;
//   -o-transition: all 0.8s ease-in-out;
//   transition: all 0.8s ease-in-out;
// }
</style>

